import { useMutation } from "@apollo/client";

import { GqlSettingsEcologicalFunctionTypeObservationTypeUnlinkInput } from "~/__generated__";

import { SettingsObservationTypeEditRoute_RemoveFunctionTypeDocument } from "../mutations.generated";

export default function useSettingsObservationTypeEditRoute_RemoveFunctionType() {
    const [mutate, { loading, error }] = useMutation(SettingsObservationTypeEditRoute_RemoveFunctionTypeDocument);

    const removeObservationTypeFunctionType = async (
        input: GqlSettingsEcologicalFunctionTypeObservationTypeUnlinkInput,
    ): Promise<void> => {
        await mutate({ variables: { input } });
    };

    return {
        removeObservationTypeFunctionType,
        loading,
        error,
    };
}
